// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2Fl15","description":"PatientConsentPreview_description__347J-"};